const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

const fetchData = async ({ uri }: any) => {
  const response = await fetch(`${REACT_APP_API_URL}/${uri}`, {
    method: "GET",
  });

  if (response.status !== 200) {
    return Promise.reject();
  }

  return response.json();
};

export default fetchData;
